import React from 'react';
import {View} from 'react-native';
import {faArrowRightLong} from '@fortawesome/free-solid-svg-icons/faArrowRightLong';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import {makeStyles} from '@rneui/themed';

import Text from '../../themed/Text';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

type SeeAllButtonProps = {
  onPress?: any;
  variant?: 'small';
  text?: string;
  spaceBetween?: boolean;
};

function SeeAllButton({
  onPress,
  text,
  variant,
  spaceBetween,
}: SeeAllButtonProps) {
  const styles = useStyles({spaceBetween});

  return (
    <PressableWithOpacityFeedback onPress={onPress}>
      <View style={styles.containerStyle}>
        <Text
          noMargin
          style={styles.text}
          variant={variant !== 'small' && 'heading1'}>
          {text ?? ''}
        </Text>
        <FontAwesomeIcon
          color={styles.text.color}
          icon={faArrowRightLong}
          size={variant !== 'small' ? 30 : 18}
        />
      </View>
    </PressableWithOpacityFeedback>
  );
}

const useStyles = makeStyles((theme, {spaceBetween}: SeeAllButtonProps) => {
  return {
    containerStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
      ...(spaceBetween ? {justifyContent: 'space-between'} : {}),
    },
    text: {
      color: theme.colors.text.heading.primary,
    },
  };
});

export default SeeAllButton;
